import Vue from 'vue'
import Vuex from 'vuex'

import sessionStore from '@/stores/session'
import overlayStore from '@/stores/overlay'

const deviceStore = {
  namespaced: true,
  state: {
    charges: [],
    chargesSummary: {},
    startDate: moment().unix(),
    endDate: moment().add(1,'days').unix()
  },
  mutations: {
    RESET_CHARGES (state, chargesObject) {
      state.charges = []
    },
    SET_CHARGES (state, chargesObject) {
      state.charges.push(chargesObject)
    },
    SET_CHARGES_SUMMARY (state, chargesObject) {
      state.chargesSummary = chargesObject
    },
    SET_START_DATE(state, value) {
      state.startDate = value
    },
    SET_END_DATE(state, value) {
      state.endDate = value
    }
  },
  actions: {
    reset ({commit, state}) {
      commit('RESET_CHARGES')
      commit('SET_CHARGES_SUMMARY', {})
      commit('SET_START_DATE', moment().unix())
      commit('SET_END_DATE', moment().add(1,'days').unix())
    },
    
    /*
    summarize ({commit, state}) {
      return new Promise((resolve, reject) => {
        Vue.axios.get(`/rest/profile/${sessionStore.state.profileId}/summarize/charges?startDate=${state.startDate}&endDate=${state.endDate}`)
        .then(response => {
          //console.log("store_charge_summarize");
          //console.log(response.data);
          commit('SET_CHARGES_SUMMARY', response.data)
          resolve()
        })
        .catch( error => {
          console.log(error);
          reject(error)
        })
      })
    },
    */


    setStartDate({commit, state, dispatch}, date) {
      // date format must be unix timestamp
      commit('SET_START_DATE', date)
    },
    setEndDate({commit, state, dispatch}, date) {
      commit('SET_END_DATE', date)
    },
    fetch ({commit, state, getters}, deviceId) {
        return new Promise((resolve, reject) => {
          if (getters.chargesForDevice(deviceId) == undefined) {
            Vue.axios.get(`/rest/profile/${sessionStore.state.profileId}/device/${deviceId}/charges`)
            .then(response => {
              let data = response.data
              data.deviceId = deviceId
              commit('SET_CHARGES', data)
              resolve()
            })
            .catch( error => {
              console.log(error)
              reject(error)
            })
          } else {
            resolve()
          }
        })
    }
  },

  /*
  getters: {
    chargesForDevice: (state, getters) => (deviceId) => {
      return state.charges.find(charge => charge.deviceId === deviceId)
    },
    // Used for dashboard graph
    monthChargeArrayForDevice: (state, getters) => (deviceId) => {
      let chargeObject = getters.chargesForDevice(deviceId)
      let dataArray = []
      if (chargeObject !== undefined && chargeObject.hasOwnProperty('sessions')) {
        let session = chargeObject.sessions[0]
        for (var i = session.graph.length - 1; i >= 0; i--) {
          let graphObject = session.graph[i]
          dataArray.push(graphObject)
        }
      }
      return dataArray
    }
  }
  */


}

export default deviceStore



// WEBPACK FOOTER //
// ./src/stores/charges.js